import React from 'react';
import Modal from '../pages/util/admin/Modal.jsx';

export default function ConfirmModal({ open, onClose, onConfirm, title = 'Confirm', message = 'Are you sure?', confirmLabel = 'Confirm', cancelLabel = 'Cancel', confirmClass = 'button-primary', cancelClass = 'button-secondary' }) {
  return (
    <Modal open={open} onClose={onClose}>
      <div style={{ padding: 24, maxWidth: 400 }}>
        <h3>{title}</h3>
        <p>{message}</p>
        <div style={{ marginTop: 24, display: 'flex', justifyContent: 'flex-end' }}>
          <button onClick={onClose} className={cancelClass}>{cancelLabel}</button>
          <button onClick={onConfirm} className={confirmClass} style={{ marginLeft: 8 }}>{confirmLabel}</button>
        </div>
      </div>
    </Modal>
  );
}
